import React from 'react';
import { GigsListing, propTypes } from '../../components/GigsListing';
import { useAfp1 } from './useAfp1';
import { useInterface } from './useInterface';

import './style.scss';

export const WidgetComponent = (props) => {
    const afp1 = useAfp1();

    useInterface();

    return <GigsListing {...props} afp1={afp1}></GigsListing>;
};

WidgetComponent.propTypes = propTypes;
